import _Table from "@material-ui/core/esm/Table";
import _TableBody from "@material-ui/core/esm/TableBody";
import _TableCell from "@material-ui/core/esm/TableCell";
import _TableHead from "@material-ui/core/esm/TableHead";
import _TableRow from "@material-ui/core/esm/TableRow";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classnames from 'classnames';
import CheckIcon from '@material-ui/icons/Check';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './info-size.scss';
class InfoSize extends Component {
  constructor(props, context) {
    super(props, context);
    _defineProperty(this, "saveChanges", () => {
      const {
        item,
        onEditItem,
        onClose
      } = this.props;
      onEditItem(item);
      onClose();
    });
    this.state = {
      sizeIndex: this.props.item.sizeInd,
      isBtnDisabled: this.props.item.isDisabledBySize[this.props.item.sizeInd]
    };
  }
  setSize(sizeInd) {
    const {
      item
    } = this.props;
    item.sizeInd = parseInt(sizeInd, 10);
    const variants = [...item.variants];
    const quantities = new Array(variants[0].quantities.length).fill(0);
    quantities[sizeInd] = 1;
    item.variants = [_objectSpread({}, item.variants[0], {
      quantities
    })];
    this.setState({
      sizeIndex: item.sizeInd,
      isBtnDisabled: item.isDisabledBySize[item.sizeInd]
    });
  }
  render() {
    const {
      item: {
        isDisabledBySize,
        prod: {
          size
        }
      }
    } = this.props;
    const {
      sizeIndex,
      isBtnDisabled
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.block
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.sizeBlock
    }, /*#__PURE__*/React.createElement(_Table, null, /*#__PURE__*/React.createElement(_TableHead, null, /*#__PURE__*/React.createElement(_TableRow, null, /*#__PURE__*/React.createElement("th", {
      colSpan: 2,
      className: classes.tableTitle
    }, "Choose size"))), /*#__PURE__*/React.createElement(_TableBody, null, size.options.map((v, i) => /*#__PURE__*/React.createElement(_TableRow, {
      key: i,
      className: classnames({
        [classes.active]: sizeIndex === i,
        [classes.unclicable]: isDisabledBySize[i]
      }, classes.row),
      onClick: () => this.setSize(i)
    }, /*#__PURE__*/React.createElement(_TableCell, {
      className: classnames(classes.checkCell, {
        [classes.disabled]: isDisabledBySize[i]
      })
    }, /*#__PURE__*/React.createElement(CheckIcon, {
      className: classes.checkIcon
    })), /*#__PURE__*/React.createElement(_TableCell, {
      className: classes.outOfStock
    }, isDisabledBySize[i] ? 'This size is out of stock.' : ''), /*#__PURE__*/React.createElement(_TableCell, {
      className: classnames(classes.tableValue, {
        [classes.disabled]: isDisabledBySize[i]
      })
    }, v)))))), /*#__PURE__*/React.createElement("div", {
      className: classes.save
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: isBtnDisabled,
      dataButton: "Confirm",
      type: "primary",
      onClick: this.saveChanges,
      className: classes.button
    }, "Confirm")));
  }
}
export default InfoSize;